import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=3b148a39"
import script from "./ProductWindow.vue?vue&type=script&lang=js"
export * from "./ProductWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports